import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/render/project/src/src/components/mdxLayouts/PostsLayout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Setting up google analytics`}</h2>
    <p>{`You will need a few things to start adding analytics to your Gatsby site. The first requirement is making a `}<a parentName="p" {...{
        "href": "https://analytics.google.com/"
      }}>{`Google Analytics account`}</a>{`. If you don't already have an account you can sign up at analytics.google.com. Once you have your account set up you will want to go to your site's stream and uncheck the "Page views" advanced option called "Page changes based on browser history events". Due to Gatsby producing single-page applications and managing the current view based on browser history events this can lead to inaccurate analytics and double requests.`}</p>
    <p>{`While you are here you will also want to find your measurement ID. Keep this in your clipboard to paste into your Gatsby config later.`}</p>
    <h2>{`Setting up Gatsby`}</h2>
    <p>{`Once you have your analytics account set up and your Gatsby project open you will want to head over to Gatsby's gtag plugin page. Here you will want to copy paste the npm install snippet and install the plugin as a dependency. Now head over to your gatsby.config file and past in the provided config object from the plugin page. If you are implementing any other tracking such as Ad Word you can add that tracking ID here as well, but for basic sites without ads, your config should look something like this.`}</p>
    <pre {...{
      "className": "grvsc-container quiet-light grvsc-ps-tuw09S",
      "data-language": "js",
      "data-index": "0"
    }}><code parentName="pre" {...{
        "className": "grvsc-code"
      }}><span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-7 grvsc-tuw09S-3"
            }}>{`modules`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`.`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-7 grvsc-tuw09S-11"
            }}>{`exports`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-15"
            }}>{`=`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`{`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`  plugins`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`:`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{` [`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`    `}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`{`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`      resolve`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`:`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-8"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-4 grvsc-tuw09S-8"
            }}>{`gatsby-plugin-google-gtag`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-8"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`      options`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`:`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`{`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`        trackingIds`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`:`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{` [`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-8"
            }}>{`'`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-4 grvsc-tuw09S-8"
            }}>{`ga-measurement-id`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-8"
            }}>{`'`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`]`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`        `}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-7 grvsc-tuw09S-3"
            }}>{`pluginConfig`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`: `}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`{`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`          head`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`:`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-5 grvsc-tuw09S-7"
            }}>{`true`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`          respectDNT`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`:`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{` `}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-5 grvsc-tuw09S-7"
            }}>{`true`}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`,`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`        `}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`}`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`      `}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`}`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`    `}</span><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-6 grvsc-tuw09S-1"
            }}>{`}`}</span></span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "grvsc-source"
          }}><span parentName="span" {...{
              "className": "grvsc-tZ0ymb-1 grvsc-tuw09S-1"
            }}>{`}`}</span></span></span></code></pre>
    <p>{`Tada, you now have google analytics added to your site!`}</p>
    <h2>{`Making sure it works`}</h2>
    <p>{`The plugin will only add the tracking snippet to your site after the site is built so to test if your plugin is working properly build and serve your site with "gatsby build" and "gatsby serve". Once you are serving your site visit your locally served site then check your analytics dashboard to be sure that you are getting information sent out.`}</p>
    <h2>{`Conclusion`}</h2>
    <p>{`I hope that this helped you make your site better. If this helped you feel free to send me a message with a topic you would like me to cover. I hope you have a great day and I'll see you in the next post.`}</p>

    <style {...{
      "className": "grvsc-styles"
    }}>{`
  .grvsc-container {
    overflow: auto;
    position: relative;
    -webkit-overflow-scrolling: touch;
    padding-top: 1rem;
    padding-top: var(--grvsc-padding-top, var(--grvsc-padding-v, 1rem));
    padding-bottom: 1rem;
    padding-bottom: var(--grvsc-padding-bottom, var(--grvsc-padding-v, 1rem));
    border-radius: 8px;
    border-radius: var(--grvsc-border-radius, 8px);
    font-feature-settings: normal;
    line-height: 1.4;
  }
  
  .grvsc-code {
    display: table;
  }
  
  .grvsc-line {
    display: table-row;
    box-sizing: border-box;
    width: 100%;
    position: relative;
  }
  
  .grvsc-line > * {
    position: relative;
  }
  
  .grvsc-gutter-pad {
    display: table-cell;
    padding-left: 0.75rem;
    padding-left: calc(var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem)) / 2);
  }
  
  .grvsc-gutter {
    display: table-cell;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }
  
  .grvsc-gutter::before {
    content: attr(data-content);
  }
  
  .grvsc-source {
    display: table-cell;
    padding-left: 1.5rem;
    padding-left: var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem));
    padding-right: 1.5rem;
    padding-right: var(--grvsc-padding-right, var(--grvsc-padding-h, 1.5rem));
  }
  
  .grvsc-source:empty::after {
    content: ' ';
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }
  
  .grvsc-gutter + .grvsc-source {
    padding-left: 0.75rem;
    padding-left: calc(var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem)) / 2);
  }
  
  /* Line transformer styles */
  
  .grvsc-has-line-highlighting > .grvsc-code > .grvsc-line::before {
    content: ' ';
    position: absolute;
    width: 100%;
  }
  
  .grvsc-line-diff-add::before {
    background-color: var(--grvsc-line-diff-add-background-color, rgba(0, 255, 60, 0.2));
  }
  
  .grvsc-line-diff-del::before {
    background-color: var(--grvsc-line-diff-del-background-color, rgba(255, 0, 20, 0.2));
  }
  
  .grvsc-line-number {
    padding: 0 2px;
    text-align: right;
    opacity: 0.7;
  }
  
  .quiet-light { background-color: #F5F5F5; }
  .quiet-light .grvsc-tZ0ymb-7 { color: #7A3E9D; }
  .quiet-light .grvsc-tZ0ymb-6 { color: #777777; }
  .quiet-light .grvsc-tZ0ymb-1 { color: #333333; }
  .quiet-light .grvsc-tZ0ymb-4 { color: #448C27; }
  .quiet-light .grvsc-tZ0ymb-5 { color: #9C5D27; }
  .quiet-light .grvsc-line-highlighted::before {
    background-color: var(--grvsc-line-highlighted-background-color, rgba(0, 0, 0, 0.05));
    box-shadow: inset var(--grvsc-line-highlighted-border-width, 4px) 0 0 0 var(--grvsc-line-highlighted-border-color, rgba(0, 0, 0, 0.2));
  }
  body[class=dark] .grvsc-ps-tuw09S {
    background-color: #1e1e1e;
    color: #c5c8c6;
  }
  body[class=dark] .grvsc-ps-tuw09S .grvsc-tuw09S-3 { color: #6089B4; }
  body[class=dark] .grvsc-ps-tuw09S .grvsc-tuw09S-1 { color: #C5C8C6FF; }
  body[class=dark] .grvsc-ps-tuw09S .grvsc-tuw09S-11 { color: #9872A2; }
  body[class=dark] .grvsc-ps-tuw09S .grvsc-tuw09S-15 { color: #676867; }
  body[class=dark] .grvsc-ps-tuw09S .grvsc-tuw09S-8 { color: #9AA83A; }
  body[class=dark] .grvsc-ps-tuw09S .grvsc-tuw09S-7 { color: #408080; }
  body[class=dark] .grvsc-ps-tuw09S .grvsc-line-highlighted::before {
    background-color: var(--grvsc-line-highlighted-background-color, rgba(255, 255, 255, 0.1));
    box-shadow: inset var(--grvsc-line-highlighted-border-width, 4px) 0 0 0 var(--grvsc-line-highlighted-border-color, rgba(255, 255, 255, 0.5));
  }
`}</style>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      